import React from 'react';

const Spinner = ({ ...props }) => (
  <div {...props} className="spinner-border spinner-border-lg text-muted" role="status" />
);

export default Spinner;
